import { Row } from "react-bootstrap";
import "./Header.css";

export default function Header(){
    return(
        <Row className="header">
            <h1>Lecturer Quotes</h1>
        </Row>
    )
}